import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MyImage from "../myImage";
import { useContext } from "react";
import { AuthContext } from "../../contexts/auth";

const MyHeader = ({ open, handleDrawerOpen }) => {

  const { user } = useContext(AuthContext);

  return (
    <AppBar position="fixed" open={open}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{  color:'white', mr: 2, ...(open && { display: "none" }) }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, color:'white' }}>
          {`${user.value.client_palo} - Gestor Mobile`}
        </Typography>
        <Box sx={{backgroundColor:'white',borderRadius:'30px',  height:'50px', width:'50px', position:'relative'}}>
          <MyImage sx={{position:'absolute', top: '5px', left: '5px', height:'40px', width:'40px'}} src={user.value.client_logo} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MyHeader;
